module.exports = __webpack_public_path__ + "media/images/hankyu_hakone_zh01-d00f13621af0c0b53d3d5cfc082ab654.jpg";